<script setup lang="ts">
const props = withDefaults(defineProps<{
  type?: 'success' | 'warning' | 'error',
  message: string,
  autoDismiss?: number,
}>(), {
  type: 'success',
  autoDismiss: 4500,
});

const emit = defineEmits<{ close: [] }>();

let timer: ReturnType<typeof setTimeout> | null = null;
const startTimer = () => {
  if(timer) clearTimeout(timer);
  if(props.autoDismiss > 0) {
    timer = setTimeout(() => emit('close'), props.autoDismiss);
  }
};
onMounted(startTimer);
watch(() => [props.message, props.type], startTimer);
onBeforeUnmount(() => {
  if(timer) clearTimeout(timer);
});
</script>

<template>
  <div class="wad4-toast" :class="`wad4-toast--${props.type}`" role="status">
    <span class="wad4-toast__message">{{ props.message }}</span>
    <button class="wad4-toast__close" type="button" aria-label="Dismiss" @click="emit('close')">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
      </svg>
    </button>
  </div>
</template>

<style lang="scss">
.wad4-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $wad4-spacing-md;
  padding: $wad4-spacing-lg;
  border-radius: $wad4-border-radius-md;
  align-self: stretch;
  box-shadow: $wad4-box-shadow-sm;

  &--success {
    background: $wad4-c-background-bg-success-primary;
    color: $wad4-c-text-text-success;
  }

  &--warning {
    background: $wad4-c-background-bg-warning-primary;
    color: $wad4-c-text-text-warning;
  }

  &--error {
    background: $wad4-c-background-bg-error-primary;
    color: $wad4-c-text-text-error;
  }

  &__message {
    @include text-size-mixin('sm');
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: $wad4-spacing-xs;
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
  }
}
</style>
